import React, { FC, useCallback, useState } from 'react';
import {useSelector} from 'react-redux';
import {internalizationState} from '../../../../stores/reducers/sections';

interface IRadioParam {
  label_ru: string;
  label_en: string;
  value: string;
}

interface Props {
  value: string;
  params: IRadioParam[];
  handleChange?: (value: string) => void;
}

const Radio: FC<Props> = ({value, params, handleChange}) => {
  const langConfig = useSelector(internalizationState);
  const [selectedValue, setSelectedValue] = useState(value);

  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue(e.target.value);
      if (handleChange) {
        handleChange(e.target.value);
      }
    },
    [handleChange]
  );

  return (
    <>
      {
        params.map((param, index) => (
            <div className="radio" key={index}>
              <label>
                <input type="radio" value={param.value} checked={selectedValue === param.value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChange(e)} />
                {langConfig.activeLangState === 'ru' ? param.label_ru : param.label_en}
              </label>
            </div>
          )
        )
      }
    </>
  )
};

export default Radio;

